
import Vue from 'vue';

import "../base/layout-bom";

import { registerComponents } from '../base/output/output-fragment-register';
registerComponents();
import PlotterLayout from './plotter.vue';
import store from "./../base/store";

import Logger from "../../shared/logger";
const LOGGER = new Logger(__filename);

new Vue({ //NOSONAR 
    store,
    el: '#app',
    render: h => h(PlotterLayout),
    mounted() {
        const that = this;
        Vue.nextTick(() => {
            that.$store.dispatch("init");
        });
    }
});

LOGGER.log("==================================");
LOGGER.log("======= PLOTTER LAYOUT ===========");
LOGGER.log("==================================");